import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { ExperienceContext, useStore, useConfigService } from '@thd-nucleus/experience-context';
import { params, string, shape, useDataModel } from '@thd-nucleus/data-sources';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';
import { shouldDisplay } from './util';

import * as analytics from './analytics/PromotionsAnalytics';
import './promotion.style.scss';

const Promotion = ({ itemId, hideConditionalPromoDescription }) => {
  const { channel } = useContext(ExperienceContext);
  // eslint-disable-next-line max-len
  /* fs:pip-hidden-promotion-types: oneOf ["buyOneGetOne", "buyOneGetPercentageOff", "buyOneGetDollarOff", "MSBONLINE", "BMSM"] */
  const hiddenPromosConfig = useConfigService('fs:pip-hidden-promotion-types');
  const hiddenPromos = hiddenPromosConfig
    ? JSON.parse(hiddenPromosConfig)
    : [];

  const { storeId } = useStore();
  const { data } = useDataModel('product', { variables: { itemId, storeId } });
  const { description, dates } = data?.product?.pricing?.promotion || {};
  const { shortDesc, longDesc } = description || {};
  const { end, start } = dates || {};

  if (!shouldDisplay({ hiddenPromos, data, hideConditionalPromoDescription })) return null;

  const specialBuy = {
    'Online Exclusive Special Buy of the Day': {
      link: '/SpecialBuy/SpecialBuyOfTheDay',
      description: 'Shop All Special Buy of the Day',
    },
    'Online Exclusive Pro Special Buy of the Week': {
      link: '/SpecialBuy/ProSpecialBuyOfTheWeek',
      description: 'Shop All Pro Special Buy of the Week',
    },
    'Online Exclusive Decor Special Buy of the Week': {
      link: '/SpecialBuy/DecorSpecialBuyOfTheWeek',
      description: 'Shop All Decor Special Buy of the Week',
    }
  };

  return (
    <div data-testid="promotion">
      {!specialBuy[shortDesc] && (
        <div className="promotion">
          <Tooltip
            channel={channel}
            content={(
              <div>
                <b>Promotion Details</b>
                <div className="promotion__tooltip">{`Price Valid: ${start} - ${end}`}</div>
                {longDesc && <div>{longDesc}</div>}
                {!longDesc && <div>{shortDesc}</div>}
              </div>
            )}
            closeButton
          >
            <button
              type="button"
              className="promotion__link"
              href="#"
              onClick={analytics.promoClickEvent}
            >
              {shortDesc}
            </button>
          </Tooltip>
        </div>
      )}
      {specialBuy[shortDesc] && (
        <div className="promotion__special-buy-wrapper">
          <div className="promotion__special-buy-icon" />
          <div>
            <div className=" promotion__special-buy-timer">Special Buy ends in&nbsp;
              <CountdownTimer
                isPromotionTimer
                endDate={end}
              />
            </div>
            <a className="promotion__special-buy-link" href={specialBuy[shortDesc].link}>
              {specialBuy[shortDesc].description}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

Promotion.displayName = 'Promotion';

Promotion.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    dataSources: string(),
    pricing: params({ storeId: string() }).shape({
      promotion: shape({
        dates: shape({
          start: string(),
          end: string()
        }),
        description: shape({
          shortDesc: string(),
          longDesc: string()
        }),
      })
    })
  })
};

Promotion.propTypes = {
  /**
  * To display the Item Id
  */
  itemId: PropTypes.string.isRequired,
  /**
  * To hide the promotion description
  */
  hideConditionalPromoDescription: PropTypes.bool
};

Promotion.defaultProps = {
  hideConditionalPromoDescription: false
};

export default Promotion;
